// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YearPicker_wrapper__Wv8-A","box":"YearPicker_box__I8NVe","span":"YearPicker_span__3-hJF"};